import PolicyPage from "../components/PolicyPage";

export default function CareGuide() {
  return (
    <PolicyPage
      testId="care-guide-page"
      eyebrow="Sumanya · Care"
      title="Take care of your jewellery. It will take care of your memories."
      subtitle="Fine jewellery deserves a little care. With the right habits, your jewellery can continue looking beautiful for years to come."
      sections={[
        {
          heading: "Gold jewellery",
          body: "Gold jewellery can develop scratches and marks with regular use. We recommend:",
          bullets: [
            "Store each piece separately to prevent scratching.",
            "Keep jewellery away from perfumes, cosmetics, hairspray and chemicals.",
            "Remove jewellery before bathing, swimming or exercising.",
            "Avoid wearing delicate jewellery during activities where it may get pulled or caught.",
            "Store jewellery in a soft pouch or jewellery box when not in use.",
          ],
        },
        {
          heading: "Diamond jewellery",
          body: "Diamonds are extremely hard, but the jewellery surrounding them can still be damaged. We recommend:",
          bullets: [
            "Avoid exposing diamond jewellery to strong impacts.",
            "Remove rings before heavy physical work or exercise.",
            "Keep diamond pieces separately so that they do not scratch other jewellery.",
            "Periodically check that stones are secure.",
            "Avoid direct contact with household chemicals and cleaning products.",
          ],
        },
        {
          heading: "Silver jewellery",
          body: [
            "Silver naturally reacts with air, moisture, perspiration and certain chemicals. As a result, silver jewellery may develop blackening or tarnishing over time.",
            "This is a natural characteristic of silver and does not indicate a problem with purity.",
          ],
          bullets: [
            "Keep silver jewellery dry.",
            "Store it in an airtight pouch or box where possible.",
            "Avoid contact with perfumes, cosmetics and chemicals.",
            "Wipe gently with a soft jewellery cloth after use.",
            "Do not store silver jewellery in humid areas.",
          ],
        },
        {
          heading: "Lightweight & delicate jewellery",
          body: "Lightweight and fancy jewellery requires extra care. Avoid:",
          bullets: [
            "Pulling or stretching the jewellery.",
            "Wearing it during physical activities.",
            "Allowing it to get caught in clothing or hair.",
            "Applying excessive force.",
            "Sleeping while wearing delicate jewellery.",
          ],
          note: "Breakage caused by accidental damage, misuse or normal wear and tear is not covered by the jewellery purity guarantee.",
        },
        {
          heading: "Cleaning",
          body: [
            "We recommend professional cleaning from time to time to maintain the appearance of your jewellery.",
            "Sumanya provides lifetime free jewellery cleaning and repair for eligible jewellery purchased from us. Only additional gold, silver, stones or other materials required for the repair may be chargeable.",
          ],
        },
        {
          heading: "One simple rule",
          body: "When in doubt, take it off. A little care today can help your jewellery stay beautiful for generations.",
        },
      ]}
    />
  );
}
